// This is the base Tamagui config for this monorepo
// It is used by the tamagui CLI to generate typings based on this project's configuration

import { typedKeys } from '@utility-nyc/typescript-functions';
import { createTamagui, createTokens, setConfig } from 'tamagui';

import { sizesSpaces, font, themes, radius, media } from './src/index';

const keyOfFirstTheme = typedKeys(themes)[0];
const colors = themes[keyOfFirstTheme];

const tamaguiConfig = createTamagui({
  themes,
  media,
  fonts: {
    body: font,
    heading: font,
  },
  tokens: createTokens({
    color: colors,
    size: sizesSpaces,
    space: { ...sizesSpaces, ...radius },
    radius,
    zIndex: sizesSpaces,
  }),
  settings: {
    autocompleteSpecificTokens: true,
    allowedStyleValues: 'somewhat-strict',
    disableSSR: true,
  },
});

setConfig(tamaguiConfig);

type TamaguiConfig = typeof tamaguiConfig;

declare module 'tamagui' {
  // overrides TamaguiCustomConfig so your custom types
  // work everywhere you import `tamagui`
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface TamaguiCustomConfig extends TamaguiConfig {}
}

export default tamaguiConfig;
